import React, { useEffect, useState } from "react";
import {fetchrootpath} from "../api_servcies/apirootpath"
import axios from 'axios'
import {setMapCentreCord, setVillagerevpoly,setVillSearchStr} from "../../redux/actions/mapaction"
import { useDispatch,useSelector } from 'react-redux';
import {openSurveySearchDialog, closeSurveySearchDialog} from '../../redux/actions/controlbuttonaction'
import Surveysearchdialogue from './Surveysearchdialogue'
import AsyncSelectSearch from '../FormComopents/Form/AsyncSelectSearch'
const villagesearchurl = `${fetchrootpath}/searchvillage`
const villsurveypolyurl = `${fetchrootpath}/point_village/revpoly_json`
const SerchVillage = () => {
    const dialogopen = useSelector(state => state.controlbutton.surveysearchdialog)
    const dispatch = useDispatch()
    const [selectedVillage, setSelectedVillage] = useState({
        selectedVillage: ''
    })
    // console.log(selectedVillage)
    const onChange = selectedVillage => {
        let longLat = selectedVillage.long_lat
        let centercord = {
            longitude: longLat[0],
            latitude: longLat[1]
        }
        setSelectedVillage({
            ...selectedVillage,
            selectedVillage: selectedVillage.label || []
        })
        dispatch(setVillSearchStr(selectedVillage.label))
        dispatch(setMapCentreCord(centercord))
    }
    const fetchData =  async(e) => {
    const searchstr = e
    if(searchstr.length>8)
        {const response = await axios.get(villagesearchurl, {
            params: {'searchstr': searchstr},
                },)
            let label_data = []
            response.data.forEach((item,index) => {
                let _label = [item.state_name, item.district_name,
                            item.subdistrict_name, item.village_name].join(',')
                let _index = index
                let _lnglat = item.village_centroid.coordinates
                let label = {
                    id : _index,
                    label:_label,
                    long_lat: _lnglat
                }
                label_data.push(label)
                

            });
                return label_data
            }
    }
    const load =  async (selectedVillage) => {
        const latlong = {
            latitude:selectedVillage.long_lat[1],
            longitude:selectedVillage.long_lat[0]
        } 
        try{
            await axios.get(villsurveypolyurl, {
                params: latlong,
                    },)
                    .then((response)=> {
                        dispatch(setVillagerevpoly(response.data[0].json_build_object))
                        dispatch(openSurveySearchDialog)
                    
                    }).catch(error => {
                    console.error('There was an error!', error);
                    });
                }
        catch (error)
        {
        console.log(error)
        }
    
    }

  useEffect(()=> {
    const timer = setTimeout(() => {
       if(selectedVillage.long_lat)
       { load(selectedVillage)}
    }, 650)
    return () => {
        clearTimeout(timer)
    };
  },[selectedVillage])
  

    return (
        <>        
        <AsyncSelectSearch
            conmplete
            defaultValue={selectedVillage.selectedVillage}
            onChange = {onChange}
            loadOptions = {fetchData}
            />
            <Surveysearchdialogue
            open ={dialogopen}
            handleClose={() => {dispatch(closeSurveySearchDialog)}}
            />
        </>

    )
}
export default SerchVillage

